// src/component/loaders/BoxSkeleton.js
import React, { useMemo } from 'react';
import { Skeleton } from '@material-ui/lab';
import { Box } from '@material-ui/core';

export default function BoxSkeleton({ rowCount = 1, height = 24, width = '100%' }) {
  const rows = useMemo(() => {
    return Array.from({ length: rowCount }, (_, i) => (
      <Box key={i} mb={1}>
        <Skeleton animation="wave" height={height} width={width} />
      </Box>
    ));
  }, [rowCount, height, width]);

  return <>{rows}</>;
}
